import { createStore, createEvent } from 'effector';

export const $chatMessages = createStore([]);
export const $chatSocketConnection = createStore(null);

export const addChatMessage = createEvent();
export const setChatMessages = createEvent();
export const setChatSocketConnection = createEvent();

$chatMessages
    .on(addChatMessage, (state, newMessage) => [...state, newMessage])
    .on(setChatMessages, (_, value) => value);

$chatSocketConnection
    .on(setChatSocketConnection, (_, value) => value);